import { useTranslation } from 'react-i18next'
import { Badge, Card, CardBody, CardHeader, CardTitle } from '@ludus/ui'
import type { CardPage } from '../../types.ts'
import { formatDate } from '../../utils/format.ts'

/** The board says the deal reached this stage — does anything in the calls support it? */
export function StageEvidencePanel({ verdicts }: { verdicts: CardPage['stageEvidence'] }) {
  const { t } = useTranslation()
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {t('pages.audits.card.stageEvidence.title', { defaultValue: 'Stage evidence' })}
        </CardTitle>
      </CardHeader>
      <CardBody>
        {verdicts.length === 0 ? (
          <p className="text-xs text-muted">
            {t('pages.audits.card.stageEvidence.none', { defaultValue: 'No stage verdicts yet.' })}
          </p>
        ) : (
          <ul className="flex flex-col gap-1 text-sm">
            {verdicts.map((v) => (
              <li key={v.id} className="flex flex-col gap-0.5">
                <span className="flex items-center gap-2">
                  <span className="text-foreground">→ {v.statusName ?? '?'}</span>
                  <span className="text-xs text-muted">{formatDate(v.occurredAt)}</span>
                  <Badge
                    tone={
                      v.verdict === 'supported'
                        ? 'success'
                        : v.verdict === 'unsupported'
                          ? 'danger'
                          : 'muted'
                    }
                    size="sm"
                  >
                    {t(`pages.audits.card.stageEvidence.verdict.${v.verdict}`, {
                      defaultValue: v.verdict,
                    })}
                  </Badge>
                </span>
                {v.explanation && <span className="text-[11px] text-muted">{v.explanation}</span>}
                {v.missing && (
                  <span className="text-[11px] text-toast-warning-text">
                    {t('pages.audits.card.stageEvidence.missing', {
                      defaultValue: 'Missing: {{what}}',
                      what: v.missing,
                    })}
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </CardBody>
    </Card>
  )
}
